export const BANK_DAY_MS = 24 * 60 * 60 * 1000

function validUtcDate(year: number, month: number, day: number): number | null {
  const result = Date.UTC(year, month - 1, day)
  const parsed = new Date(result)
  if (
    parsed.getUTCFullYear() !== year ||
    parsed.getUTCMonth() !== month - 1 ||
    parsed.getUTCDate() !== day
  ) {
    return null
  }
  return result
}

export function parseStatementDate(value: string): number | null {
  const text = value.trim()
  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text)
  if (iso) return validUtcDate(Number(iso[1]), Number(iso[2]), Number(iso[3]))

  const nz = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(text)
  if (nz) return validUtcDate(Number(nz[3]), Number(nz[2]), Number(nz[1]))
  return null
}

export function isUtcCalendarDate(value: number): boolean {
  return Number.isInteger(value) && value >= 0 && value % BANK_DAY_MS === 0
}

export function bankDateRange(rows: readonly { transactionDate: number }[]): {
  start: number
  end: number
} | null {
  if (rows.length === 0) return null
  const dates = rows.map((row) => row.transactionDate)
  return { start: Math.min(...dates), end: Math.max(...dates) + BANK_DAY_MS }
}
